import { ColDef } from '@ag-grid-community/core';
import { AssetTypes } from '@tassat/common-definitions';
import { formatAsAsset } from '@tassat/utility';

import { AssetBalancesWithPrice } from 'Selectors/assetBalancesStats';

const getFormatedValue = (positionString: keyof AssetBalancesWithPrice, data?: AssetBalancesWithPrice) => {
    if (!data) return;
    const isSecurity = data.assetType === AssetTypes.ASSET;

    return formatAsAsset(data[positionString],
        isSecurity ? data.security : data.currency,
        isSecurity ? 'ticker' : 'symbol');
};

export const columnDefs: ColDef<AssetBalancesWithPrice>[] = [
    {
        field: 'AssetId',
        headerName: 'Asset',
        menuTabs: [],
        suppressHeaderMenuButton: true,
        sortable: false,
        valueGetter: ({ data }) => data?.assetType === AssetTypes.ASSET ? data?.security?.Ticker : data?.currency?.Ticker,
        flex: 8
    },
    {
        field: 'BeginningOfDayAvailPosition',
        headerName: 'Beginning Available Balance',
        menuTabs: [],
        suppressHeaderMenuButton: true,
        sortable: false,
        valueGetter: ({ data }) => getFormatedValue('BeginningOfDayAvailPosition', data),
        flex: 18
    },
    {
        field: 'AvailPosition',
        headerName: 'Total Available Balance',
        menuTabs: [],
        suppressHeaderMenuButton: true,
        sortable: false,
        valueGetter: ({ data }) => getFormatedValue('AvailPosition', data),
        flex: 17
    },
    {
        field: 'CurrentPosition',
        headerName: 'Total Current Balance',
        menuTabs: [],
        suppressHeaderMenuButton: true,
        sortable: false,
        valueGetter: ({ data }) => getFormatedValue('CurrentPosition', data),
        flex: 17
    },
    {
        field: 'OmnibusPosition',
        headerName: 'Omnibus Balance',
        menuTabs: [],
        suppressHeaderMenuButton: true,
        sortable: false,
        valueGetter: ({ data }) => getFormatedValue('OmnibusPosition', data),
        flex: 17
    },
    {
        field: 'security.Price',
        headerName: 'Asset Price',
        menuTabs: [],
        suppressHeaderMenuButton: true,
        sortable: false,
        valueGetter: ({ data }) => data?.assetType === AssetTypes.ASSET ? formatAsAsset(data?.security?.Price, undefined, 'symbol') : '-',
        flex: 10
    }
];